import { safeJsonParse } from '@/utils';
const expandShowStyle = (obj: any) => {
  // const showStyleObj = obj?.showStyle ? JSON.parse(obj?.showStyle) : {};
  const showStyleObj = safeJsonParse(obj?.showStyle, {});
  return { ...obj, ...showStyleObj };
};

// 获取商品促销标签的文案；promotionType的含义：优惠券: 2  ,单品促销: 1, 总价促销: 10  ,时效标签: 3
export const getPromotionObj = (promotions: any) => {
  const promotionObj: any = {
    couponInfo: '-100',
    single_promotion: '-100',
    amount_promotion: '-100',
    service_type: '-100',
    time_label: '-100',
    labelName: [],
    brand_name: '-100',
  };
  const single_promotion: string[] = [];
  const amount_promotion: string[] = [];
  const service_type: string[] = [];
  const couponInfo: string[] = [];
  const time_label: string[] = [];
  if (promotions) {
    promotions.map((promotion: any) => {
      promotion = expandShowStyle(promotion);
      //需要屏蔽掉老版本的秒杀倒计时营销标签
      if (promotion.srType === 3) {
        return;
      }
      switch (promotion.promotionType) {
        case 1:
          single_promotion.push(`${promotion.text}${promotion?.endTime || ''}`);
          break;
        case 10:
          amount_promotion.push(`${promotion.text}${promotion?.endTime || ''}`);
          break;
        case 2:
          couponInfo.push(`${promotion.text}${promotion?.endTime || ''}`);
          break;
        case 3:
          time_label.push(`${promotion.text}${promotion?.endTime || ''}`);
          break;
        case 4:
          service_type.push(`${promotion.text}${promotion?.endTime || ''}`);
          break;
      }
      //type：6的图片上展示的营销标签埋点
      if (promotion.type === 6) {
        if (promotionObj.labelName.length > 2) return;
        promotionObj.labelName.push(promotion.text || '');
      }
      //商卡品牌文案埋点参数
      if (promotion.type === 7) {
        promotionObj.brand_name = promotion.text || '-100';
      }
    });
    promotionObj.couponInfo = couponInfo.length > 0 ? couponInfo.join(';') : '-100';
    promotionObj.single_promotion =
      single_promotion.length > 0 ? single_promotion.join(';') : '-100';
    promotionObj.amount_promotion =
      amount_promotion.length > 0 ? amount_promotion.join(';') : '-100';
    promotionObj.time_label = time_label.length > 0 ? time_label.join(';') : '-100';
    promotionObj.service_type = service_type.length > 0 ? service_type.join(';') : '-100';
    return promotionObj;
  }
  return promotionObj;
};
